import React from 'react';
import styles from './TotalsTable.styles.scss';
import cn from 'classnames';
import {
  calculateTotalExcludingTax,
  calculateTotalIncludingTax,
  calculateTotalVatAmount,
  formatNumberWithCurrency,
} from '../../../../../../../../helpers/invoiceHelpers';
import { useTranslation } from 'react-i18next';

const TotalsTable = ({ items, invoice, values }) => {
  const { t, i18n } = useTranslation();

  return (
    <div className={cn('mt-5', styles.container)}>
      <div className={styles.inner}>
        <div className={cn(styles.headers, styles.firstHeader)}>
          <p>{t('createInvoice.invoice_total_amount_excluding_vat')}</p>
        </div>
        <div className={styles.data}>
          {formatNumberWithCurrency(
            Number(calculateTotalExcludingTax(items, values)).toFixed(3),
            invoice.currency,
            i18n.language,
          )}
        </div>
      </div>
      <div className={styles.inner}>
        <div className={styles.headers}>
          <p>{t('createInvoice.vat_total_amount')}</p>
        </div>
        <div className={styles.data}>
          {formatNumberWithCurrency(
            Number(calculateTotalVatAmount(items, values)).toFixed(3),
            invoice.currency,
            i18n.language,
          )}
        </div>
      </div>
      <div className={styles.inner}>
        <div className={styles.headers}>
          <p>{t('createInvoice.invoice_gross_total_inclusive_vat')}</p>
        </div>
        <div className={styles.data}>
          {formatNumberWithCurrency(
            Number(calculateTotalIncludingTax(items, values)).toFixed(3),
            invoice.currency,
            i18n.language,
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(TotalsTable);
